import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function Confluences() {
  return (
    <>
      <Container fluid className="home-section" id="home">
        <header>
          <nav>
            <ul>
              {/* <li><Link to="/">Home</Link></li> */}
              <li className="active-page">(Confluences)</li>
              {/* <li><Link to="/project">Projects</Link></li> */}
            </ul>
          </nav>
        </header>
        
        <Container className="home-content">
          <Row>
            <Col md={{span: 8, order:1}} xs={{span: 12, order:2}} className="home-about-description">
              <div style={{fontFamily: 'Inconsolata, monospace', lineHeight: '1.6'}}>
                <h1 style={{fontSize: '2.5em', marginBottom: '1em', fontWeight: 'normal'}}>Confluence</h1>
                <p style={{fontSize: '1.1em', marginBottom: '0.5em'}}><em>noun</em></p>
                <p style={{fontSize: '1.1em', marginBottom: '0.5em', letterSpacing: '0.1em'}}>con·flu·ence</p>
                <p style={{fontSize: '1.1em', marginBottom: '1.5em', letterSpacing: '0.1em'}}>\ˈkän-ˌflü-ən(t)s\</p>
                <p style={{fontSize: '1.1em', marginBottom: '2em', maxWidth: '600px'}}>
                  A point where two or more flowing bodies of water join together to form a single channel
                </p>
                
                <div style={{marginTop: '3em', fontSize: '1em', fontStyle: 'italic'}}>
                  <p>Thank you for your presence. Your life is a river that flows deeply. May it continue to be present and to flow with others in this shared time and space.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Confluences;
